/**
 * Configurações específicas para o cliente "BRB"
 */
const settings: ClientSettings = {
  name: "BRB",
  in100authority: "o BRB CRÉDITO, FINANCIAMENTO E INVESTIMENTO S/A",
  downloadTermText: "O BRB",
  theme: {
    token: {
      colorPrimary: "#023E7C",
    },
  },
  assets: {
    logo: '/logo.png',
    favicon: '/favicon.png',
    card: '/card.png',
    consignedCard: '/consigned-card.png',
    refinCard: '/refin-card.png',
    bankLogo: '/bank-logo.png'
  },
};

export default settings;
